<template>
    <div>
        <div class="xtt-img-list">
            <slot></slot>
            <div v-for="(imgId, index) in imgs" :key="index">
                <img :src="$showImg(imgId)" alt @click="showCarousel(index)" />
                <i v-if="editable" class="icon-close" @click="deleteRec(index)"></i>
            </div>
        </div>
        <div class="xtt-preimg" v-if="showPreview">
            <i class="icon-close close-top fs-12" @click="showPreview = false"></i>
            <el-carousel :interval="5000" trigger="click" :autoplay="false" :initial-index="initialIndex">
                <el-carousel-item v-for="(id, index) in imgs" :key="'previewImage' + index">
                    <img :src="$showImg(id)" alt />
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ImgPreview',
    props: {
        imgs: Array,
        editable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            initialIndex: 0,
            showPreview: false
        };
    },
    methods: {
        /**
         * 删除记录
         */
        deleteRec(index) {
            let imgId = this.imgs[index];
            this.imgs.splice(index, 1);
            this.$emit('deleted', imgId);
        },
        /** 点击图片显示图片轮播 */
        showCarousel(index) {
            this.showPreview = true;
            this.initialIndex = index;
        }
    }
};
</script>

<style scoped>
</style>
